<template>
  <div>
    <div class="mb-6">
      <input-text-validated
        ref="value.templateId"
        v-model="value.templateId"
        input-class="w-full"
        label="Template ID"
        rules="required"
        placeholder="763fdeae-b11b-4b9c-b27a-77c9c9556afe"
      />
    </div>

    <creatify-variants v-model="value.variants" />
  </div>
</template>

<script>
import InputTextValidated from '@/components/form/text-validated'
import CreatifyVariants from '@/components/form/creatify-variants'

export default {
  components: {
    InputTextValidated,
    CreatifyVariants
  },

  props: {
    value: {
      type: Object,
      required: true
    }
  }
}
</script>
